import React from 'react';
import { CreditType } from '@screens/players/player.actions/credits/types/credit.type';
import { MainDialogContent } from '@components/dialog/main.dialog.content';
import { SelectionButton, SelectionButtonGroup, SelectionIcon } from '@screens/players/player.actions/credits/credit.type.selection.styles';
import { CenteredRoot } from '@styles/common';

interface CreditTypeSelectionProps {
  onChange(value: CreditType): void;
}

export const CreditTypeSelection = ({ onChange }: CreditTypeSelectionProps) => {
  function selectStats(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    onChange(CreditType.stats);
  }

  function selectBonus(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    onChange(CreditType.bonus);
  }

  // TODO remove this var to use Bonus component
  const disableTemporarily = false;

  return (
    <MainDialogContent>
      <CenteredRoot>
        <p>What do you want to send to this player?</p>

        <SelectionButtonGroup size='large' aria-label='Credit type selection'>
          <SelectionButton onClick={selectStats}>
            <SelectionIcon>inventory</SelectionIcon>
            Stats
          </SelectionButton>
          {disableTemporarily && (
            <SelectionButton onClick={selectBonus}>
              <SelectionIcon>local_offer</SelectionIcon>
              Bonus
            </SelectionButton>
          )}
        </SelectionButtonGroup>
      </CenteredRoot>
    </MainDialogContent>
  );
};
